export default __webpack_public_path__ + "static/media/hurry_up_1.24248fa9.gif";